/* auto-generated: @mui/icons-material */
import Base from '@mui/icons-material/Close';
import {withMuiAdapter} from '@common/icons/with-mui-adapter';

export const CloseIcon = withMuiAdapter(Base, 'Close');
